export interface AuthorizedPerson {
  id: string;
  name: string;
  dni: string;
}

export interface Client {
  id: string;
  companyName: string;
  cif: string;
  email?: string;
  phone?: string;
  address?: string;
  authorizedPersons: AuthorizedPerson[];
}

/** Datos de facturacion de la venta en curso: a quien se le emite y como. */
export interface BillingSelection {
  client: Client | null;
  authorizedPerson: AuthorizedPerson | null;
  shippingAddress: string | null;
  generateInvoice: boolean;
  isTaxFree: boolean;
  /**
   * Direccion a la que mandar la factura: la de la ficha del cliente, o la que
   * se teclee en caja para esta venta. '' si no se conoce ninguna.
   */
  invoiceEmail: string;
  /**
   * Si la factura se manda o no. Va aparte de la direccion a proposito: apagar
   * el envio no borra lo tecleado, asi volver a encenderlo no obliga a
   * escribirlo otra vez.
   */
  sendInvoiceEmail: boolean;
}

export const EMPTY_BILLING: BillingSelection = {
  client: null,
  authorizedPerson: null,
  shippingAddress: null,
  generateInvoice: false,
  isTaxFree: false,
  invoiceEmail: '',
  sendInvoiceEmail: false
};
